import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResponse } from '../../../shared/commons/page-response';

export interface ProductCodeSubDto {
  id?: number;
  productId?: number;
  productCode?: string;
  productTitle?: string;
  productGroupTitle?: string;
  productGroupTypeTitle?: string;
  value?: string;
}

@Injectable({ providedIn: 'root' })
export class ProductCodeSubService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/product-code-subs';

  getAllProductCodeSubs(page: number, size: number, search: string = '', state: number | null = null): Observable<PageResponse<ProductCodeSubDto>> {
    return this.http.get<PageResponse<ProductCodeSubDto>>(this.apiUrl + '?page=' + page + '&size=' + size + '&search=' + encodeURIComponent(search) + (state == null ? '' : '&state=' + state));
  }

  getProductCodeSubById(id: number): Observable<ProductCodeSubDto> {
    return this.http.get<ProductCodeSubDto>(`${this.apiUrl}/${id}`);
  }

  createProductCodeSub(dto: ProductCodeSubDto): Observable<ProductCodeSubDto> {
    return this.http.post<ProductCodeSubDto>(this.apiUrl, dto);
  }

  updateProductCodeSub(id: number, dto: ProductCodeSubDto): Observable<ProductCodeSubDto> {
    return this.http.put<ProductCodeSubDto>(`${this.apiUrl}/${id}`, dto);
  }

  deleteProductCodeSub(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
